import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { JVInput } from "../../shared/JVInput";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ITimesheet, VerifyStatus } from "../../models/Timesheet";
import { Fetch } from "../../shared/Fetch";
import { JVRadioBtn } from "../../shared/JVRadioBtn";

interface IProps {
    singleData: ITimesheet,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

const schema = yup.object({
    verify_Status: yup.number().required("Verify Status is required"),
    verify_Comment: yup.string().when('verify_Status', (val: VerifyStatus) => {
        return (val === VerifyStatus.UnVerified) ?
            yup.string().required("Comment is required*") :
            yup.string().nullable()
    })
});

export const VerifyForm = (props: IProps) => {
    const [loading, setLoading] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset, setValue } = useForm<ITimesheet>({
        resolver: yupResolver(schema),
        defaultValues: { verify_Status: VerifyStatus.Verified, verify_Comment: "" },
        shouldFocusError: false
    });

    const onSubmit = (data: ITimesheet) => {
        saveToDB(data);
    }

    const saveToDB = async (data: ITimesheet) => {
        setLoading(true);

        const response = await Fetch("Timesheet/verify", "PUT", data, null, props.toast);
        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: "TimeSheet Verify Status Changed.", life: 3000 });
            props.setReload(!props.reload);
        }
        setLoading(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset();
    }

    useEffect(() => {
        if (props.open) reset(props.singleData);
        if (!props.singleData.verify_Status) setValue("verify_Status", VerifyStatus.Verified);
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '50vw' }} header="Verify Consultant TimeSheet" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVRadioBtn column={1} name="verify_Status" required label="Verify" control={control} data={[{ label: "Verified", value: VerifyStatus.Verified }, { label: "Rejected", value: VerifyStatus.Rejected }]} error={errors.verify_Status?.message} />
                <JVInput column={1} label="Comment" control={control} name="verify_Comment" error={errors.verify_Comment?.message} />
                <div className="col-12 md:col-12 flex gap-4">
                    <Button className="field col md:col" label="UPDATE" type="submit" loading={loading}></Button>
                </div>
            </form>
        </Dialog>
    );
}